import React, { useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ArrowDownCircle from "../Icons/ArrowDownCircle";
import CheckIcon from "../Icons/CheckRound";
import Button from "./Button";

const propTypes = {
  value: PropTypes.any,
  isSubmitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  name: PropTypes.string.isRequired,
  accept: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired
};

const defaultProps = {
  isSubmitting: false,
  handleSubmit: () => {},
  setFieldTouched: () => {},
  children: "Drop file here",
  className: "py-4 px-6"
};

const DropHere = ({
  name,
  value,
  accept,
  children,
  className,
  handleSubmit,
  isSubmitting,
  setFieldValue,
  setFieldTouched
}) => {
  /**
   * hooks
   */
  const fileUploadRef = useRef();

  return (
    <Wrapper
      className={`${className} text-truncate gap-6`}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        const items = e.dataTransfer.items;
        if (items) {
          if (items[0].kind === "file") {
            setFieldValue(name, items[0].getAsFile());
            setTimeout(() => setFieldTouched(name, true));
            setTimeout(() => handleSubmit(), 500);
          }
        }
      }}
    >
      <div className="d-flex gap-2 align-items-center text-truncate">
        <div>
          {value ? (
            <CheckIcon color="var(--bs-primary)" />
          ) : (
            <ArrowDownCircle variant="outline" color="var(--bs-gray-100)" />
          )}
        </div>
        <small className="caption text-gray-100 text-truncate">
          {children}
        </small>
      </div>

      <Button
        height={36}
        className="px-4"
        variant="secondary"
        loader={{ size: "sm" }}
        onClick={() => fileUploadRef?.current?.click()}
        {...{ isSubmitting }}
      >
        Browse
      </Button>

      <input
        type="file"
        accept={accept}
        className="d-none"
        ref={fileUploadRef}
        onChange={({ currentTarget: { files } }) => {
          setFieldValue(name, files[0]);
          setTimeout(() => setFieldTouched(name, true));
          setTimeout(() => handleSubmit(), 500);
        }}
      />
    </Wrapper>
  );
};

/**
 * styles
 */
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 0.125rem;
  justify-content: space-between;
  border: 1px dashed var(--bs-gray-40);
`;

DropHere.propTypes = propTypes;
DropHere.defaultProps = defaultProps;

export default DropHere;
